import React, { useEffect, useState } from "react";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { institutionRegister } from "../../services/auth.service";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from 'react-i18next';
import useSessionStore from '../../store/useSessionStore';
import { MIX_PANEL_EVENTS } from '../../utils/constans';

const SignInstForm = () => {
  const [loading, setLoading] = useState(false);
  const [isDisabledEmail, setIsDisabledEmail] = useState(false);
  const { show } = useSnackbarStore();
  const { setInitialEvent } = useMixPanel();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setUser, setIsTeacherOnboarding } = useSessionStore();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const email = queryParams.get("email");

  const mutation = useMutation(institutionRegister, {
    onSuccess: (data) => {
      setInitialEvent(data,MIX_PANEL_EVENTS.login);
      setUser(data?.user);
      navigate("/");
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
    },
  });

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate({...form, code});
  };

  useEffect(() => {
    if(email) {
      const parsedEmail = email.replace(/ /g, '+');
      setValue("email", parsedEmail);
      setIsDisabledEmail(true)
      setIsTeacherOnboarding(true);
    }
    // eslint-disable-next-line
  },[])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className="alt-h1">{t('register')}</h2>
      <div className="form-warpper">
        <div className="input-text mt-0">
          <label className="input-label">{t('email')}:</label>
          <input
            className="input-box w-full"
            type="email"
            disabled={isDisabledEmail}
            {...register("email", {
              required: t('requiredEmail'),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: t('notValidEmail'),
              },
            })}
          />
          {errors.email && <span className="error">{errors.email.message}</span>}
        </div>
        <div className="input-text mt-2">
          <label className="input-label">{t('password')}:</label>
          <input
            className="input-box w-full"
            type="password"
            {...register("password", { required: t('requiredPassword') })}
          />
          {errors.password && (
            <span className="error">{errors.password.message}</span>
          )}
        </div>
        <div className="form-CTA">
          <Button
            label={loading ? `${t('initSession')} ...` : t('enter')}
            variant="primary"
            typeB="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default SignInstForm;